import { render, staticRenderFns } from "./class-card.vue?vue&type=template&id=67a16d1c"
import script from "./class-card.vue?vue&type=script&lang=js"
export * from "./class-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports